import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

const RESTRICTED = new Set(["R", "TV-MA", "PG-13"]);

export default function AgeGate({ rating, onConfirmed, children }) {
  const { user, setUser } = useAuth();
  const [show, setShow] = useState(RESTRICTED.has(rating) && !(user?.age_confirmed));
  const [year, setYear] = useState("");
  const [err, setErr] = useState("");

  if (!show) return children;

  const confirm = async () => {
    const y = parseInt(year, 10);
    if (!y || y < 1900 || y > new Date().getFullYear()) return setErr("Enter a valid birth year");
    const minAge = rating === "R" || rating === "TV-MA" ? 17 : 13;
    const age = new Date().getFullYear() - y;
    if (age < minAge) return setErr(`You must be ${minAge}+ to watch ${rating}-rated content.`);
    try {
      if (user) {
        const r = await api.post("/me/age", { birth_year: y });
        setUser({ ...user, age_confirmed: true, birth_year: y });
        void r;
      }
      setShow(false);
      onConfirmed && onConfirmed();
    } catch {
      setErr("Failed to confirm");
    }
  };

  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center px-4">
      <div className="tv-glass rounded-2xl p-8 max-w-md w-full text-center">
        <div className="text-xs uppercase tracking-[0.3em] text-tv-live font-bold">Age Restricted</div>
        <div className="font-display font-black text-3xl text-white mt-2">Rating: {rating}</div>
        <p className="text-white/70 mt-3 text-sm">This content is rated <span className="font-bold text-white">{rating}</span>. Confirm your birth year to continue.</p>
        <input
          data-testid="age-birth-year"
          type="number" min="1900" max={new Date().getFullYear()}
          value={year} onChange={(e) => setYear(e.target.value)}
          placeholder="YYYY"
          className="mt-5 w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-center text-white text-xl tracking-widest outline-none focus:border-tv-brand"
        />
        {err && <div className="text-red-400 text-sm mt-2">{err}</div>}
        <button onClick={confirm} data-testid="age-confirm" className="mt-5 w-full bg-tv-accent hover:bg-yellow-400 text-black font-bold py-3 rounded-full">Confirm & Continue</button>
        <button onClick={() => window.history.back()} className="mt-2 text-white/60 text-xs hover:text-white">Cancel</button>
      </div>
    </div>
  );
}
